import { ToastType } from '../components/Toast/Toast.types';
import { IAccount } from '../models/account';
import { getDeviceStatesApi } from './api/api';
import { ToastHelper } from './toast.util';

export interface LocationPowerConsumptionParams {
  locationId?: string;
  orderBy?: string;
  descending?: boolean;
  pageNumber?: number;
  options?: any;
}

export interface RoomPowerConsumptionParams {
  locationId: string;
  roomId?: string;
  orderBy?: string;
  descending?: boolean;
  pageNumber?: number;
  options?: any;
}

export const getLocationPowerConsumption = (
  params: LocationPowerConsumptionParams,
  onGetData,
  getAccount: () => IAccount,
  onDataError?
) => {
  const { locationId, orderBy, descending, pageNumber, options } = params;
  return getDeviceStatesApi(getAccount())
    .deviceStateGetLocationPowerConsumption(
      locationId,
      orderBy,
      descending,
      pageNumber,
      options
    )
    .then(data => onGetData(data))
    .catch(error => {
      onDataError(error);
      ToastHelper(
        ToastType.DANGER,
        'Error during getting location power consumption data. Please try again or contact with system administrator',
        error
      );
    });
};

export const getRoomPowerConsumption = (
  params: RoomPowerConsumptionParams,
  onGetData,
  getAccount: () => IAccount,
  onDataError?
) => {
  const {
    locationId,
    roomId,
    orderBy,
    descending,
    pageNumber,
    options
  } = params;
  return getDeviceStatesApi(getAccount())
    .deviceStateGetRoomPowerConsumption(
      locationId,
      roomId,
      orderBy,
      descending,
      pageNumber,
      options
    )
    .then((data: any) => onGetData(data))
    .catch(error => {
      onDataError(error);
      ToastHelper(
        ToastType.DANGER,
        'Error during getting location power consumption data. Please try again or contact with system administrator',
        error
      );
    });
};
